import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Moon, Compass } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-24 bg-abyss relative overflow-hidden" data-id="element-9">
      <div className="max-w-7xl mx-auto px-6" data-id="element-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-11">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-13">
              Illuminating the{' '}
              <span className="text-mystic-500" data-id="element-14">Darkest Corners</span> of
              Creativity
            </h2>
            <div className="space-y-6 text-gray-400 leading-relaxed" data-id="element-15">
              <p data-id="element-16">
                At Ombreludique, we believe that fear is an art form. Founded in
                Limassol, we noticed a gap in the industry: exceptional horror
                and mystery games were being overlooked by mainstream publishers
                who didn't understand the nuance of the genre.
              </p>
              <p data-id="element-17">
                We are not just publishers; we are curators of the uncanny. Our
                mission is to provide a dedicated platform for developers who
                dare to explore the shadows, ensuring their visions reach the
                audience they deserve without compromising their artistic
                integrity.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-8" data-id="element-18">
              <div className="flex flex-col gap-3" data-id="element-19">
                <Eye className="w-8 h-8 text-mystic-500" data-id="element-20" />
                <h3 className="text-lg font-serif font-bold text-white" data-id="element-21">
                  Vision
                </h3>
                <p className="text-sm text-gray-500" data-id="element-22">
                  Seeing potential where others see only darkness.
                </p>
              </div>
              <div className="flex flex-col gap-3" data-id="element-23">
                <Moon className="w-8 h-8 text-mystic-500" data-id="element-24" />
                <h3 className="text-lg font-serif font-bold text-white" data-id="element-25">
                  Atmosphere
                </h3>
                <p className="text-sm text-gray-500" data-id="element-26">
                  Prioritizing immersion and narrative depth.
                </p>
              </div>
              <div className="flex flex-col gap-3" data-id="element-27">
                <Compass className="w-8 h-8 text-mystic-500" data-id="element-28" />
                <h3 className="text-lg font-serif font-bold text-white" data-id="element-29">
                  Guidance
                </h3>
                <p className="text-sm text-gray-500" data-id="element-30">
                  Navigating the market with genre expertise.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative h-[500px] w-full rounded-lg overflow-hidden border border-white/10 group" data-id="element-31">
            <div className="absolute inset-0 bg-gradient-to-t from-abyss via-transparent to-transparent z-10" data-id="element-32" />
            {/* Abstract atmospheric imagery representation */}
            <div className="absolute inset-0 bg-shadow flex items-center justify-center" data-id="element-33">
              <div className="w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gray-800 via-abyss to-black opacity-80" data-id="element-34" />
              <div className="absolute inset-0 opacity-30 bg-[url('https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?q=80&w=2574&auto=format&fit=crop')] bg-cover bg-center grayscale mix-blend-overlay" data-id="element-35" />
            </div>

            <div className="absolute bottom-8 left-8 right-8 z-20" data-id="element-36">
              <blockquote className="font-serif text-xl italic text-gray-300 border-l-2 border-mystic-500 pl-4" data-id="element-37">
                "We don't just sell games. We sell the sleepless nights that
                follow."
              </blockquote>
              <p className="mt-4 text-sm text-mystic-400 font-bold tracking-wider uppercase" data-id="element-38">
                — Seraphina Voss, Creative Director
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}